import { GlobalLayout, ProtectedLayout } from "@components/index";
import { Navigate, Route, Routes } from "react-router-dom";

import { useHasAccess } from "@hooks/useHasAccess";
import { ReactNode } from "react";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { Roles } from "~/Utils/Roles";
import { defaultRedirectURL } from "~/Utils/StringConstants";
import { InactivityDetector } from "../Utils/InactivityDetector";
import { globalRoutes, openRoutes, protectRoutes } from "./Routes";

export function GlobalRouter() {
  // const { user } = useAuth();
  const { hasRole } = useHasAccess();
  const [user] = useLocalStorage("user", {});

  const getElementwithAccess = (element: ReactNode, roles: string[]) => {
    if (!user) {
      return <Navigate to="/auth/login" />;
    } else {
      return hasRole(roles) ? (
        <InactivityDetector>{element}</InactivityDetector>
      ) : (
        <Navigate to="/unauthorized-entry" />
      );
    }
  };

  return (
    <Routes>
      <Route
        path="*"
        element={<Navigate to={"/"} />}
      />
      <Route
        path="/"
        element={<Navigate to={user ? defaultRedirectURL(user?.role) : "/auth/login"} />}
      />
      <Route element={<ProtectedLayout />}>
        {protectRoutes.map(({ path, element, roles }) => {
          return (
            <Route
              path={path}
              element={getElementwithAccess(element, roles)}
              key={path}
            />
          );
        })}
      </Route>
      <Route element={<GlobalLayout />}>
        {openRoutes.map(({ path, element, roles }) => {
          return (
            <Route
              path={path}
              element={getElementwithAccess(element, roles)}
              key={path}
            />
          );
        })}
      </Route>
      <Route element={<GlobalLayout />}>
        {globalRoutes.map(({ path, element, ...res }) => {
          let defaultUrl = defaultRedirectURL("MAGP_CREATOR");
          if (user?.role === Roles.MAGP_REVIEWER) {
            defaultUrl = defaultRedirectURL("MAGP_REVIEWER");
          }
          return (
            <Route
              path={path}
              {...res}
              element={
                user && (["/auth/login"].includes(path) || path.includes("?redirect=")) ? (
                  <Navigate to={defaultUrl} />
                ) : (
                  element
                )
              }
              key={path}
            />
          );
        })}
      </Route>
    </Routes>
  );
}
